import React from 'react';

import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { InputText } from 'primereact/inputtext';

interface ChecklistItemProps {
  onChange: ({ }: any) => void;
  onDelete: ({ }: any) => void;
  value: string;
}

const ChecklistItem: React.FC<ChecklistItemProps> = ({ onChange, onDelete, value }) => {
  return (
    <div className="checklistItemContainer">
      <div className="checklistItem">
        <InputText className="p-mr-3"
          value={value}
          onChange={onChange}
          placeholder="Insira um título para o item"
        />
        <FontAwesomeIcon icon={faTimes} size="1x" onClick={onDelete} cursor="pointer" />
      </div>
    </div>
  );
}

export default ChecklistItem;
